import {
    ChangeDetectionStrategy,
    Component,
    computed,
    contentChild,
    input,
    output,
} from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogTitle } from '@angular/material/dialog';
import { NgIcon } from '@ng-icons/core';
import { QpxButton, QpxIcon, QpxTypography } from '../../directives';
import { DialogSubtitle } from './dialog-subtitle';
import type { DialogPresentation } from './models';

@Component({
    selector: 'qpx-dialog-header',
    imports: [MatButtonModule, NgIcon, QpxButton, QpxIcon, QpxTypography],
    templateUrl: './dialog-header.html',
    styleUrl: './dialog-header.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: {
        '[style.--dialog-title-height]': 'hasSubtitle() ? "76px" : null',
    },
    hostDirectives: [MatDialogTitle],
})
export class DialogHeader {
    //#region Inputs
    public readonly title = input.required<string>();
    public readonly titleId = input('dialog-title');
    public readonly presentation = input<DialogPresentation>('standard');
    public readonly showCloseButton = input(true);
    public readonly closeLabel = input('Close');
    //#endregion

    //#region Template references
    protected readonly subtitle = contentChild(DialogSubtitle);
    //#endregion

    //#region State
    protected readonly hasSubtitle = computed(
        () => this.subtitle() !== undefined
    );
    //#endregion

    //#region Outputs
    public readonly dismiss = output<void>();
    //#endregion

    //#region Template methods
    protected onDismiss(): void {
        this.dismiss.emit();
    }
    //#endregion
}
